import React, { Component } from "react";
import { connect } from "react-redux";
import { toggleForm } from "../../actions/ui_actions";
import {
  deselectAll,
  deselectCarrier,
  deselectOrder,
  deselectShipment,
  deselectRelation,
  deselectContact
} from "../../actions/select_actions";

import { CommandBarButton } from "office-ui-fabric-react/lib/Button";

class ToggleForm extends Component {
  toggleForm = () => {
    if (this.props.addOrEdit === "add") {
      switch (this.props.form) {
        case "shipment":
          this.props.deselectAll();
          break;
        case "order":
          this.props.deselectOrder();
          break;
        case "carrier":
          this.props.deselectAll();
          break;
        case "relation":
          this.props.deselectRelation();
          break;
        case "contact":
          this.props.deselectContact();
          break;
        default:
          return null;
      }
      this.props.toggleForm(this.props.form, this.props.addOrEdit);
    } else this.props.toggleForm(this.props.form, this.props.addOrEdit);
  };

  render() {
    const { addOrEdit, disabled, form } = this.props;
    return (
      <CommandBarButton
        styles={{ root: { padding: "10px" } }}
        disabled={disabled}
        iconProps={
          addOrEdit === "add" ? { iconName: "Add" } : { iconName: "Edit" }
        }
        title={addOrEdit === "add" ? `Add new ${form}` : `Edit ${form}`}
        onClick={this.toggleForm}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    shipment: state.selected.shipment,
    order: state.selected.order,
    carrier: state.selected.carrier
  };
};

export default connect(mapStateToProps, {
  toggleForm: toggleForm,
  deselectAll: deselectAll,
  deselectCarrier: deselectCarrier,
  deselectOrder: deselectOrder,
  deselectShipment: deselectShipment,
  deselectRelation: deselectRelation,
  deselectContact: deselectContact
})(ToggleForm);



// WEBPACK FOOTER //
// ./src/common/Buttons/_ToggleForm.js